export const POPULAR_CONVERTER_PAIRS = [
  {
    from: "INR",
    to: "BTC",
  },
  {
    from: "INR",
    to: "ETH",
  },
  {
    from: "INR",
    to: "BNB",
  },
  {
    from: "INR",
    to: "WRX",
  },
];

export const FIAT_CURRENCIES_OPTIONS = [
  {
    label: "Indian Rupee",
    value: "inr",
    icon: "",
  },
  {
    label: "US Dollar",
    value: "usd",
    icon: "",
  },
];

export const DEFAULT_CONVERSION_RATE_FETCH_AMOUNT = 1;
export const DEFAULT_VALUE_PRECISION_LENGTH = 7;

export const DEFAULT_LEFT_CURRENCY = "inr";
export const DEFAULT_RIGHT_CURRENCY = "btc";
export const DEFAULT_LEFT_AMOUNT = 1000;
export const DEFAULT_RIGHT_AMOUNT = 0;
export const DEFAULT_POPULAR_PAIR = "inrbtc";
